import { useState } from "react";
import { Snackbar } from "@mui/material";
import Masthead from "./common/Masthead";
import { ASSISTANTS, buildPlanPrompt } from "../helper/aiPrompt";
import { copyText } from "../helper/clipboard";
import { useLanguage } from "../i18n/LanguageContext";

const LANGUAGES = [
  { key: "en", label: "English" },
  { key: "de", label: "Deutsch" },
];

// Explains how to let ChatGPT, Claude, Copilot & co. plan a session and hand it
// over as a focussuite link, with the prompt ready to copy or to open
// straight in the assistant. The prompt is in the interface language
// unless another one is picked here.
export default function AiPlanner() {
  const { language: uiLanguage, t } = useLanguage();
  const [chosenLanguage, setLanguage] = useState(null);
  const language = chosenLanguage || uiLanguage;
  const [copied, setCopied] = useState(false);
  const prompt = buildPlanPrompt(language);

  return (
    <div className="content-page">
      <Masthead
        title={t("aiPlanner.title")}
        subtitle={t("aiPlanner.subtitle")}
      />

      <div className="content-card ai-planner">
        <h2>{t("aiPlanner.howItWorks")}</h2>
        <ol>
          <li>{t("aiPlanner.step1")}</li>
          <li>{t("aiPlanner.step2")}</li>
          <li>{t("aiPlanner.step3")}</li>
        </ol>

        <div
          className="example-variants ai-language"
          role="group"
          aria-label={t("aiPlanner.promptLanguage")}
        >
          {LANGUAGES.map((option) => (
            <button
              key={option.key}
              type="button"
              lang={option.key}
              className={`example-chip${
                option.key === language ? " is-selected" : ""
              }`}
              aria-pressed={option.key === language}
              onClick={() => setLanguage(option.key)}
            >
              {option.label}
            </button>
          ))}
        </div>

        <pre className="ai-prompt" lang={language}>
          {prompt}
        </pre>

        <div className="example-variants">
          {ASSISTANTS.map((assistant) => (
            <a
              key={assistant.name}
              className="example-chip"
              href={assistant.url(prompt)}
              target="_blank"
              rel="noreferrer"
              onClick={async () => {
                if (assistant.copyFirst) {
                  setCopied(await copyText(prompt));
                }
              }}
            >
              {t("aiPlanner.openIn", { name: assistant.name })}
            </a>
          ))}
          <button
            type="button"
            className="example-chip"
            onClick={async () => setCopied(await copyText(prompt))}
          >
            {t("aiPlanner.copyPrompt")}
          </button>
        </div>

        <h2>{t("aiPlanner.otherTitle")}</h2>
        <p>
          {t("aiPlanner.otherBefore")}{" "}
          <a href="/llms.txt" target="_blank" rel="noreferrer">
            focussuite.de/llms.txt
          </a>
          .
        </p>

        <h2>{t("aiPlanner.changeTitle")}</h2>
        <p>
          {t("aiPlanner.changeBefore")}{" "}
          <strong>{t("aiPlanner.changeButton")}</strong>{" "}
          {t("aiPlanner.changeAfter")}
        </p>
      </div>

      <Snackbar
        open={copied}
        autoHideDuration={2500}
        onClose={() => setCopied(false)}
        message={t("aiPlanner.copied")}
      />
    </div>
  );
}
